import React, {useContext} from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import {ShippingInstructionRoutes, SiReferences, SiTemplates, FormRoutes, IntegrationsRoute, PerformanceRoute, Administrative} from './neo-routes';
import {GasMenuRoutes, GasFormRoutes} from '../pages/gas/shared/routes';
import DashboardLayout from "../layouts/Dashboard";
import AuthLayout from "../layouts/Auth";
import Page404 from "../pages/auth/Page404";
import SignIn from "../pages/auth/SignIn";
import Loading from "../components/Loader";
import {CurrentUserContext} from "../components/CurrentUserContext";

const childRoutes = (Layout, routes) =>
    routes.map(({component: Component, guard, children, path}, index) => {
        const Guard = guard || React.Fragment;

        return children ? (
            children.map((element, index) => {
                const Guard = element.guard || React.Fragment;
                const ElementComponent = element.component || React.Fragment;

                return (
                    <Route
                        key={index}
                        path={element.path}
                        exact
                        render={(props) => (
                            <Layout>
                                <Guard>
                                    <ElementComponent {...props} />
                                </Guard>
                            </Layout>
                        )}
                    />
                );
            })
        ) : Component ? (
            <Route
                key={index}
                path={path}
                exact
                render={(props) => (
                    <Layout>
                        <Guard>
                            <Component {...props} />
                        </Guard>
                    </Layout>
                )}
            />
        ) : null;
    });


const Routes = () => {
    const {rights, currentUser} = useContext(CurrentUserContext);
    if (currentUser === undefined || !currentUser.id) {
        return (
            <Router>
                <Switch>
                    {
                        (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') &&
                        <Route
                            render={() => (
                                <AuthLayout>
                                    <SignIn/>
                                </AuthLayout>
                            )}
                        />
                    }
                    {
                        (process.env.NODE_ENV !== 'development') &&
                        <Route
                            render={() => (
                                <AuthLayout>
                                    <Loading/>
                                </AuthLayout>
                            )}
                        />
                    }
                </Switch>
            </Router>
        )
    }
    const allowedRoutes = [];
    if (rights.includes("ROLE_SI_USER")) {
        allowedRoutes.push([ShippingInstructionRoutes]);
    }
    if (rights.includes("ROLE_SI_ADMIN") || rights.includes("ROLE_SI_EDITOR")) {
        allowedRoutes.push([SiTemplates]);
        allowedRoutes.push([SiReferences]);
    }
    if (rights.includes("ROLE_ADMIN")) {
        allowedRoutes.push([Administrative])       
    }
    if(rights.includes("ROLE_INT_USER")|| rights.includes("ROLE_ONECP_USER")|| rights.includes("ROLE_ONECP_ADMIN")){
        allowedRoutes.push([IntegrationsRoute])
    }
    if(rights.includes("ROLE_STATUS_USER")){
        allowedRoutes.push([PerformanceRoute])
    }
    if (rights.includes("ROLE_GAS_ADMIN")) {
        allowedRoutes.push([GasMenuRoutes]);
    }

    return (
        <Router>
            <Switch>
                {allowedRoutes.map(r => childRoutes(DashboardLayout, r))}
                {childRoutes(DashboardLayout, [FormRoutes, GasFormRoutes])}
                <Route path="/sign-in"
                       render={() => (
                           <AuthLayout>
                               <SignIn/>
                           </AuthLayout>
                       )}
                />
                <Route
                    render={() => (
                        <AuthLayout>
                            <Page404/>
                        </AuthLayout>
                    )}
                />
            </Switch>
        </Router>
    );
}

export default Routes;